import { useQuery } from "react-query";
import { getOfficeVendors } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetOfficeVendors = () => {
  return useQuery("GetOfficeVendors", getOfficeVendors, {
    refetchOnWindowFocus: false,
  });
};
